module.exports = __webpack_public_path__ + "img/position_1.e12d3de8.png";